"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const evaluate_1 = require("../../evaluate");
function evaluateContentForCurriculumUpdation(command, user, content, allParentContents, states) {
    const events = [];
    const updatedStates = immer_1.default(states, draftStates => {
        // Evaluate self
        const evaluateContentPayload = evaluate_1.evaluate(command, user, content, draftStates);
        draftStates = evaluateContentPayload.states;
        events.push(...evaluateContentPayload.events);
        // Evaluate parents
        allParentContents.forEach(parentContent => {
            const evaluateParentContentPayload = evaluate_1.evaluate(command, user, parentContent, draftStates);
            draftStates = evaluateParentContentPayload.states;
            events.push(...evaluateParentContentPayload.events);
        });
    });
    return {
        states: updatedStates,
        events
    };
}
exports.evaluateContentForCurriculumUpdation = evaluateContentForCurriculumUpdation;
//# sourceMappingURL=evaluateContentForCurriculumUpdation.js.map